import { useDisplayDate } from "./useDisplayDate"

export function useReadableDate(
  day: string,
  options?: Parameters<typeof useDisplayDate>[0],
): string {
  const displayDate = useDisplayDate(options)
  return displayDate(day)
}
